import React, {useState} from "react";

import {useParams} from "react-router";
import {useQuery} from "react-query";

import {getIndicator} from "services/Indicators.service";

import {i18n} from "translate/i18n";
import {EditableDefault} from "../../../components/Table/editableDefault";
import {newHeaderTable, newRowsTable} from "../../../utils/actions";
import {toast} from "react-toastify";
import {useUser} from "../../../store/providers/app";

const FormTable = () => {

    let {id} = useParams();
    let { user } = useUser()

    const [tables, setTables] = useState([])
    const [status, setStatus] = useState('')
    const [idEn, setIdEn] = useState();

    const {data, isLoading, isFetching} = useQuery(["tables_indicator", id],
        () => {
            return id && getIndicator(id)
        }, {
            onSuccess: (response) => {
                setStatus(response.status)
                setIdEn(response?.id_en)
                setTables(response.tables)
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'));
            },
            retry: false,
            refetchOnWindowFocus: false
        }
    )

    const handleNewTable = () => {
        setTables([...tables, {
            indicator_id: id,
            title: '',
            headers: newHeaderTable,
            rows: newRowsTable,
        }])
    }

    const handleRemoveTable = (position) => {
        setTables([...tables.filter((_, index) => index !== position)])
    }

    return (
        <>
            { user.profile !== 7 &&
                <div className="d-flex justify-content-end mb-4">
                    <button type="button" className="btn btn-outline-success px-3 py-2"
                            onClick={() => handleNewTable()}>
                        <i className="bi bi-plus" /> {i18n.t('label.newTable')}
                    </button>
                </div>
            }

            <div className="accordion" id="accordionExample">

                { tables?.map((item, index) =>
                    <div className="accordion-item mb-0" key={index}>
                        <h2 className="accordion-header" id={`heading-table-${index}`}>
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target={`#table-${index}`} aria-expanded="false" aria-controls={`table-${index}`}>
                                #{index} - <b className="ps-1">{ item.titulo }</b>
                            </button>
                        </h2>
                        <div id={`table-${index}`} className="accordion-collapse collapse" aria-labelledby={`heading-table-${index}`}
                             data-bs-parent="#accordionExample">
                            <div className="accordion-body p-0">
                                <EditableDefault
                                    status={status}
                                    table={item}
                                    index={index}
                                    idEn={idEn}
                                    removeData={handleRemoveTable}
                                    usersIndicator={data?.users}
                                    indicator={data?.codigo + ' - ' + data?.titulo}
                                />
                            </div>

                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default FormTable
